import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/cone/Fun cone chocolate.png";
import BiscuitImg from "../../../assets/products/cone/Chocolate-Cone.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 7,
  },
  {
    grams: 12,
  },
];

export default function ChocolateConeProduct() {
  return (
    <>
      <Helmet>
        <title>Chocolate Cone – BearBitz | Premium Biscuits & Treats</title>
        <meta
          name="description"
          content="Explore BearBitz Chocolate Cone — crisp wafer cones filled with rich chocolate. View pack sizes and global specifications."
        />
        <meta
          name="keywords"
          content="Chocolate Cone, BearBitz Chocolate Cone"
        />
        <link rel="canonical" href="https://www.bearbitz.in/cone/chocolate-cone" />
        <meta property="og:title" content="Chocolate Cone – BearBitz" />
        <meta
          property="og:description"
          content="Crisp wafer cone filled with chocolate cream by BearBitz, export-ready and premium."
        />
      </Helmet>

      <ProductTemplate
        productTitle="CHOCOLATE"
        productImage={BisImg}
        description="Delight in the crunchy Fun Cone, filled with creamy sweetness that makes every bite a joyful treat. Perfect for kids and adults alike, satisfy your sweet cravings anytime."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#68171A"
        sectionBgColor="#FFDDA4"
        productBgcolor="#FFECCB"
        tableheadBgcolor="#68171A"
        tableBgcolor="#FFF8EB"
        footerBgcolor="#68171A"
      />
    </>
  );
}
